export default __webpack_public_path__ + "static/media/ISKO CLASS-8 EXAM PATTERN 2026-27.2b2e5c88.pdf";